var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRoundButton',{staticClass:"download-all-documents-button",attrs:{"size":36,"is-transparent":"","icon":"download","tooltip-text":_vm.$t('page.opportunity-details.document-manipulations.download-all'),"tooltipPlacement":"top","is-loading":_vm.downloading},nativeOn:{"click":function($event){return _vm.downloadAll.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }